import Accordion from 'accordion-js';

export const accordions = () => {
	const accordionContainers = document.querySelectorAll('.tile__accordion');

	if (!accordionContainers.length) {
		return;
	}

	const expandedIconSvg = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
		<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 4.07143H9V5.35714H0V4.07143Z" fill="#008C66"/>
		</svg>
	`)}`;

	const swapIcon = (accordionElement, isOpen) => {
		const icon = accordionElement.querySelector('.tile__accordion-icon');

		if (!icon) {
			return;
		}

		if (!icon.dataset.collapsedSrc) {
			icon.dataset.collapsedSrc = icon.src;
		}

		icon.src = isOpen ? expandedIconSvg : icon.dataset.collapsedSrc;
	};

	new Accordion('.tile__accordion', {
		elementClass: 'tile__accordion-elem',
		triggerClass: 'tile__accordion-top',
		panelClass: 'tile__accordion-desc',
		activeClass: 'is-open',
		duration: 320,
		showMultiple: false,
		openOnInit: [],
		onOpen: (currentElement) => {
			swapIcon(currentElement, true);
		},
		onClose: (currentElement) => {
			swapIcon(currentElement, false);
		},
	});

	accordionContainers.forEach((container) => {
		container.querySelectorAll('.tile__accordion-elem').forEach((element) => {
			swapIcon(element, false);
		});
	});
};